import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { memo } from "react";

import {
  setHotelFilters,
  useHotelFilter,
} from "../../state/extract-hotel-filter-slice";
import { renderHotelRatingStars } from "../shared/hotel-rating-stars";
import { HotelAccordion } from "./hotel-accordion";

export const HotelRatingFilter = memo(() => {
  const dispatch = useAppDispatch();
  const { defaultOption, selectedOption } = useAppSelector(useHotelFilter);
  const isLoading = useAppSelector(
    (state) => state.selectedHotelData.isLoading,
  );

  const state = defaultOption?.ratings as string[];
  const selected = selectedOption?.ratings;

  const handleChange = (value?: string) => {
    if (!value) return;

    const isSelected = selected?.some((item) => item === value);

    const updatedValue = isSelected
      ? selected?.filter((item) => item !== value)
      : [...(selected ?? []), value];

    dispatch(setHotelFilters({ ratings: updatedValue }));
  };

  const sorted = Array.isArray(state)
    ? [...state].sort((a, b) => Number(a) - Number(b))
    : [];

  return (
    <HotelAccordion
      value={"ratings"}
      label={"Star Rating"}
      className="truncate"
    >
      {sorted?.map((item, index) => (
        <div key={index} className="flex items-center space-x-2 truncate">
          <Checkbox
            disabled={isLoading}
            id={item}
            onCheckedChange={() => handleChange(item)}
            checked={selected?.includes(item) ?? false}
          />
          <Label htmlFor={item} className="font-normal cursor-pointer w-full ">
            <div className=" truncate">
              <span className="flex gap-1">
                <span className="flex gap-1">
                  {renderHotelRatingStars(Number(item))}
                </span>
                <span className="text-muted-foreground">-</span>
                <span className="text-muted-foreground">({item})</span>
              </span>
            </div>
          </Label>
        </div>
      ))}
    </HotelAccordion>
  );
});

HotelRatingFilter.displayName = "HotelRatingFilter";
